import { Component, Input, OnInit } from '@angular/core';
import { WebItem } from 'src/app/core/models/api/web-item.model';

@Component({
    selector: 'app-faq-questions',
    templateUrl: './faq-questions.component.html',
    styleUrls: ['./faq-questions.component.scss']
})
export class FaqQuestionsComponent implements OnInit {

    @Input() items: WebItem[];
    
    constructor() { }

    ngOnInit() { }

}
